import { Component } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { closeWindow } from '../shared/utils/utils';

@Component({
  selector: 'app-inactive-link',
  standalone: true,
  imports: [LottieComponent],
  templateUrl: './inactive-link.component.html',
  styleUrl: './inactive-link.component.css'
})
export class InactiveLinkComponent {
  options: AnimationOptions = {
    path: 'assets/animations/inactive-link.json',
    loop: 1
  }

  close() {closeWindow()}
}
